import URLResolver from 'core/utils/URLResolver';
import routes from 'admin/urlRoutes';

export default new URLResolver(routes);
